// extracted by mini-css-extract-plugin
export default {"project-settings":"styles_project-settings__wpwcC","project-block":"styles_project-block__kAT2v","block-label":"styles_block-label__zBhWW"};